import { combineReducers } from 'redux';
import profile from './sourceProfile';

const sourcesReducer = combineReducers({
  profile,
});

export default sourcesReducer;
